import { render, staticRenderFns } from "./BiasListSitesMail.vue?vue&type=template&id=6a5c6224&scoped=true&"
import script from "./BiasListSitesMail.vue?vue&type=script&lang=js&"
export * from "./BiasListSitesMail.vue?vue&type=script&lang=js&"
import style0 from "./BiasListSitesMail.vue?vue&type=style&index=0&id=6a5c6224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c6224",
  null
  
)

export default component.exports